var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperlinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30 8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.354 5.5H4a3 3 0 0 0 0 6h2.354a.5.5 0 0 0 0-1H4a2 2 0 0 1 0-4h2.354a.5.5 0 0 0 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.646 10.5H12a3 3 0 0 0 0-6H9.646a.5.5 0 0 0 0 1H12a2 2 0 0 1 0 4H9.646a.5.5 0 0 0 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.354 8a.5.5 0 0 0 0 1h3.292a.5.5 0 0 0 0-1H6.354z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlinkIcon);
export default __webpack_public_path__ + "static/media/hyperlink-icon.16f0c820779d58bd23d563d53254cdd5.svg";
export { ForwardRef as ReactComponent };